<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-right-left padding-top">
      <Cell>
        <DatePicker v-model="month" type="month" format="yyyy-MM" placeholder="选择月份" style="width:150px"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" @click="loadData" :loading="loading">查询</Button>
      </Cell>
    </Row>

    <div class="h-panel-body padding-top">
      <Alert class="margin-right-left" type="info">对比会计科目与资产卡片的原值、累计折旧是否一致，差异行不为 0 请及时核查。</Alert>
      <Table :datas="rows" :border="true" :loading="loading" class="margin-top">
        <TableItem title="项目" prop="section" :width="160"></TableItem>
        <TableItem title="数据来源" prop="type" :width="120"></TableItem>
        <TableItem title="期初" align="right">
          <template slot-scope="{data}">
            <span :class="diffStyle(data)">{{ num(data.opening) }}</span>
          </template>
        </TableItem>
        <TableItem title="本期借方(增加)" align="right">
          <template slot-scope="{data}">
            <span :class="diffStyle(data)">{{ num(data.debitAmount) }}</span>
          </template>
        </TableItem>
        <TableItem title="本期贷方(减少)" align="right">
          <template slot-scope="{data}">
            <span :class="diffStyle(data)">{{ num(data.creditAmount) }}</span>
          </template>
        </TableItem>
        <TableItem title="期末" align="right">
          <template slot-scope="{data}">
            <span :class="diffStyle(data)">{{ num(data.ending) }}</span>
          </template>
        </TableItem>
      </Table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssetsCheck',
  data() {
    let now = new Date();
    return {
      month: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`,
      rows: [],
      loading: false
    };
  },
  methods: {
    num(val) {
      let n = Number(val);
      return isNaN(n) ? '-' : n.toFixed(2);
    },
    diffStyle(data) {
      if (data.type !== '差异') {
        return '';
      }
      return Math.abs(Number(data.opening) + Number(data.debitAmount) + Number(data.creditAmount) + Number(data.ending)) > 0.01
        ? 'diff-warn' : 'diff-ok';
    },
    rangeOfMonth() {
      let [year, m] = this.month.split('-').map(Number);
      let start = new Date(year, m - 1, 1);
      let end = new Date(year, m, 0);
      let fmt = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      return {start: fmt(start), end: fmt(end)};
    },
    loadData() {
      this.loading = true;
      let {start, end} = this.rangeOfMonth();
      this.$api.pro.assetsCheck({start, end}).then(({data}) => {
        this.rows = data || [];
      }).finally(() => this.loading = false);
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<style lang="less" scoped>
.diff-warn {
  color: #ed4014;
  font-weight: bold;
}
.diff-ok {
  color: #19be6b;
}
.margin-top {
  margin-top: 10px;
}
</style>
